export const KEY_MAPPING = Object.freeze({
	BACKSPACE: {
		KEY: "Backspace",
	},
	SPACE: {
		KEY: "Space",
	},
	TAB: {
		KEY: "Tab",
	},
	LEFT_ARROW: {
		KEY: "ArrowLeft",
	},
	RIGHT_ARROW: {
		KEY: "ArrowRight",
	},
	UP_ARROW: {
		KEY: "ArrowUp",
	},
	DOWN_ARROW: {
		KEY: "ArrowDown",
	},
	ENTER: {
		KEY: "Enter",
	},
	ESCAPE: {
		KEY: "Escape",
	},
});
